import React from 'react';
import { Download } from 'lucide-react';
import { PageHero, SectionTitle, Card, Input } from '../components/PageUI';

const MateriaisPage = () => {
  const materials = [
    { title: 'E-book: Gestão 360°', type: 'E-book' },
    { title: 'Checklist de operação logística', type: 'Checklist' },
    { title: 'Planilha de fluxo de caixa', type: 'Planilha' },
    { title: 'Webinar: BI na prática', type: 'Webinar' },
    { title: 'Infográfico: integração 4 em 1', type: 'Infográfico' },
    { title: 'Guia de implementação ERP', type: 'Guia' }
  ];

  return (
    <div>
      <PageHero
        eyebrow="Materiais gratuitos"
        title="Conteúdo para acelerar sua operação."
        subtitle="E-books, checklists e planilhas para times de distribuição e varejo."
        primaryCta={{ label: 'Quero baixar', href: '#download' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Biblioteca"
            title="Materiais disponíveis"
            description="Selecione e receba por e-mail."
          />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {materials.map((item) => (
              <Card key={item.title}>
                <Download className="w-6 h-6 text-[#FF6B35]" />
                <h3 className="text-xl font-semibold mt-3">{item.title}</h3>
                <p className="text-sm text-slate-200/70">{item.type}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section id="download" className="bg-slate-900/80">
        <div className="container mx-auto px-8 lg:px-12 py-16 max-w-2xl">
          <SectionTitle
            eyebrow="Download"
            title="Preencha para receber"
            description="Enviaremos o material no seu e-mail corporativo."
          />
          <form className="space-y-4">
            <Input label="Nome completo" placeholder="Digite seu nome" />
            <Input label="E-mail corporativo" type="email" placeholder="voce@empresa.com" />
            <Input label="Empresa" placeholder="Nome da empresa" />
            <button type="submit" className="w-full px-6 py-3 rounded-xl font-black text-lg bg-[#FF6B35] text-white">
              Quero receber
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default MateriaisPage;
